export const selfAssessmentQuestions = [
  'leverage data',
  'being responsive',
  'pleasant & fun',
  'recognize others',
  'follow-through',
  'handling conflicts',
  'dominates discussions',
  'conflict management',
  'having relevant knowledge, skills, and abilities',
  'expecting quality',
  'keeping the team on track',
  'interacting with teammates',
  'contributing to the teams work'
];

export const relevantKnowledgeQuestions = [
  'Conflict Management',
  'Having Relevant Knowledge, Skills, and Abilities',
  'Expecting Quality',
  'Keeping the Team on Track',
  'Interacting with Teammates',
  'Contributing to the Teams Work'
];

export const handlingConflictsQuestions = [
  'Leverage data',
  'Being responsive',
  'Pleasant & fun',
  'Recognize others',
  'Follow-through',
  'Handling Conflicts',
  'Dominates discussions'
];


// WEBPACK FOOTER //
// ./src/data/peer-feedback.js